import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { Resolver, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { ERefundStatus } from '../../../../shared/enums/refund/ERefundStatus';
import { handleError } from '../../../../shared/functions/handleError';
import { IRefund } from '../../../../shared/interfaces/refund/IRefund';
import { AdminRefundService } from '../service';
import RefundForm from './RefundForm';

export const refundSchema = yup.object().shape({
  title: yup.string().required(),
  description: yup.string().required(),
  refundStatus: yup
    .mixed<ERefundStatus>()
    .oneOf(Object.values(ERefundStatus))
    .required(),
  amount: yup.number().required(),
});
const RefundCreate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { handleSubmit, control } = useForm<IRefund>({
    resolver: yupResolver(refundSchema) as unknown as Resolver<IRefund>,
    defaultValues: {
      refundStatus: ERefundStatus.PENDING,
    },
  });

  const submitHandler = (state: IRefund) => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append('body', JSON.stringify(state));
    if (state?.file) {
      formData.append('file', state?.file);
    }
    AdminRefundService.create(formData)
      .then((response) => {
        if (response) {
          navigate(-1);
          enqueueSnackbar(
            t('toasts.successfullyCreated', { title: state?.title }),
            {
              variant: 'success',
            },
          );
        }
      })
      .catch((err) => handleError(err))
      .finally(() => setIsLoading(false));
  };

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <RefundForm control={control} isLoading={isLoading} />
    </form>
  );
};

export default RefundCreate;
